module.exports = __webpack_public_path__ + "img/deposit-bg.0e552bfb.svg";